/*
 * Word host strategy.
 * Delegates to the co-located WordHost class which wires up the shared
 * chat UI, agent service, and auth — with stubbed action handlers.
 */

import type { IHostStrategy } from "../host-strategy";

export class WordHostStrategy implements IHostStrategy {
  readonly hostType = "Word";

  async init(): Promise<void> {
    const { WordHost } = await import("./word");
    await new WordHost().init();
  }
}
